import React from 'react';
import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';
import { useLocale } from 'hooks/useLocale';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './DirectorModal.module.css';

type Props = {
  showModal: boolean;
  closeModal: () => void;
};

export const DirectorModal: React.FunctionComponent<Props> = ({
  showModal,
  closeModal,
}) => {
  const { locale } = useLocale();

  const COMPANY_HOUSE_URL =
    'https://find-and-update.company-information.service.gov.uk/';

  return (
    <Modal
      onClose={closeModal}
      isOpen={showModal}
      title="Your client needs to be a director of their company"
      size="medium"
      className={styles.modal}
    >
      <p className={styles.content}>
        Check with the applicant that they are correctly listed as a director of
        their company on{' '}
        <a
          onClick={() => {
            Amplitude.track(
              Events.introducerPortal.introducerPortalEventCreator({
                event: AMPLITUDE_EVENTS.externalLinkClicked,
                locale,
                payload: {
                  'Page name': document.title,
                  URL: window.location.pathname,
                  'CTA destination': 'Companies house',
                  'CTA text': 'Companies House',
                  'CTA URL': COMPANY_HOUSE_URL,
                },
              }),
            );
          }}
          className={styles.link}
          href={COMPANY_HOUSE_URL}
          target="_blank"
          rel="noreferrer"
        >
          Companies House
        </a>
        .
      </p>
      <Button type="button" className={styles.button} onClick={closeModal}>
        I understand
      </Button>
    </Modal>
  );
};
